// extracted by mini-css-extract-plugin
module.exports = {"detailsContainer":"PublicStoryCard_detailsContainer__Nt1q3","publishedTime":"PublicStoryCard_publishedTime__7Fvy_","badgeContainer":"PublicStoryCard_badgeContainer__yGl8P"};